const FORMATTER_SHORT = new Intl.DateTimeFormat(undefined, {
	weekday : 'short',
	day     : 'numeric',
	month   : 'short',
	year    : 'numeric',
})

const FORMATTER_LONG = new Intl.DateTimeFormat(undefined, {
	weekday : 'long',
	day     : 'numeric',
	month   : 'long',
	year    : 'numeric',
})

const Filters = {
	install(Vue, options) {
		Vue.filter('longDate', (inputDate) => {
			return FORMATTER_LONG.format(inputDate)
		});

		Vue.filter('shortDate', (inputDate) => {
			return FORMATTER_SHORT.format(inputDate)
		});

		Vue.filter('shortDay', (inputDate) => {
			const part = FORMATTER_SHORT.formatToParts(inputDate).find(part => part.type === 'day')
			return part.value
		});

		Vue.filter('shortWeekday', (inputDate) => {
			const part = FORMATTER_SHORT.formatToParts(inputDate).find(part => part.type === 'weekday')
			return part.value
		});

		Vue.filter('dayNumber', (inputDate) => {
			const part = FORMATTER_SHORT.formatToParts(inputDate).find(part => part.type === 'weekday')
			return part.value
		});

		Vue.filter('shortMonth', (inputDate) => {
			const part = FORMATTER_SHORT.formatToParts(inputDate).find(part => part.type === 'month')
			return part.value
		});

		Vue.filter('eventDateSummary', function(event) {
			if (event.isRanged) {
				return FORMATTER_SHORT.format(new Date(event.startIso)) + ' - ' + FORMATTER_SHORT.format(new Date(event.endIso))
			}

			return FORMATTER_SHORT.format(new Date(event.startIso))
		});

		Vue.filter('venueNameAndTown', function(venue) {
			if (venue.nameContainsTown) {
				return venue.name
			}

			return venue.town ? `${venue.name}, ${venue.town}` : venue.name ;
		});
	}
};

export default Filters;
